import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import React, { FormEventHandler } from 'react'
import { Link, useNavigate } from 'react-router'
import { useApiForgotPassword } from '../../api/account/apiUsers'
import { Button } from '../../genericComponents/Button'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'
import { AuthPageContainer } from '../../genericComponents/layout/AuthPageContainer'
import { FlexContainer } from '../../genericComponents/layout/FlexContainer'
import { FormLabel } from '../../genericComponents/layout/FormLabel'

export const ForgotPasswordPage: React.FC = () => {
  const { mutateAsync: forgotPasswordSubmit } = useApiForgotPassword()

  const navigate = useNavigate()

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    const form = event.target as HTMLFormElement
    if (form.checkValidity()) {
      event.preventDefault()
      const emailAddressField = form.elements.namedItem('email') as HTMLInputElement
      const emailAddress = emailAddressField.value
      void forgotPasswordSubmit({
        emailAddress,
      }).then(() => {
        void navigate(`/pw_resetted?emailAddress=${emailAddress}`)
      })
      return false
    } else {
      form.reportValidity()
    }
  }

  return (
    <AuthPageContainer>
      <FlexContainer
        align="items-center"
        justify="justify-center"
        className={'flex-col ' + INPUT_FORM_COMMON_SIZE}
      >
        <img src={hmd_softlock_logo} alt="" className="mb-6 w-40" />

        <h2 className="text-primaryFontColor text-base font-semibold text-center my-5">
          Forgot password?
        </h2>
        <p>Enter your email below and we’ll email you instruction on how to reset your password.</p>

        <form
          method="post"
          action="/forgot_pw"
          onSubmit={handleSubmit}
          className="flex flex-col flex-wrap w-full"
        >
          <FormLabel htmlFor="email" className="sr-only">
            Email
          </FormLabel>
          <input
            id="email"
            type="email"
            className="box-border border border-borderColor w-full min-h-12 px-6 py-3"
            placeholder="Email address"
            required={true}
            autoFocus={true}
            autoComplete="username"
            name="emailAddress"
          />

          <Button type="submit" className="self-center mt-8 mb-8 w-full">
            Reset password
          </Button>
        </form>

        <Link
          to={`/login`}
          className="text-linkColor cursor-pointer no-underline flex justify-center"
        >
          Return to Sign in
        </Link>
      </FlexContainer>
    </AuthPageContainer>
  )
}
